import ReactGA from 'react-ga4';

export const useAnalytics = () => {
  // 네이버 광고 로그 분석
  const onNaverAnalytics = ({ data }) => {
    const script = document.createElement('script');
    script.src = '//wcs.naver.net/wcslog.js';
    script.async = true;

    document.body.appendChild(script);
    const wcs = window.wcs;

    window.wcs_add['wa'] = 's_133d9347ccdf';

    var _nasa = {};
    if (wcs) {
      _nasa['cnv'] = wcs.cnv('1', data ? data.finalPrice : 0);
      window.wcs_do(_nasa);
    }

    return () => {
      document.body.removeChild(script);
    };
  };

  /** GA 전자상거래 트래킹 임시 - 추후 GA4로 대체 */
  const gaEnhancedEcommerce = ({
    data,
    isPurchase = false,
    isRefund = false,
  }) => {
    ReactGA.initialize('G-XKXG1H3NVR');

    if (isPurchase) {
      const { itemName, defaultPrice, id, finalPrice, finalShippingFee } = data;

      ReactGA.gtag('event', 'purchase', {
        currency: 'KRW',
        transaction_id: id,    // Transaction ID.
        value: finalPrice,
        shipping: finalShippingFee,
        items: [
         {
           item_id: itemName,
           item_name: itemName,
           price: defaultPrice,
           quantity: 1
         },
       ]
      });
    }

    if (isRefund) {
      ReactGA.gtag('event', 'refund', {
        transaction_id: data.id,
      });
    }
  };

  return { onNaverAnalytics, gaEnhancedEcommerce };
};
